import { render } from "./Expediente.vue?vue&type=template&id=f393d0c0&scoped=true"
import script from "./Expediente.vue?vue&type=script&lang=js"
export * from "./Expediente.vue?vue&type=script&lang=js"

import "./Expediente.vue?vue&type=style&index=0&id=f393d0c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f393d0c0"]])

export default __exports__